import axios from "axios";

const TOKEN_STORAGE_KEY = "token";

axios.interceptors.request.use((config) => {
  if (typeof window === "undefined") return config;

  const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (
      typeof window !== "undefined" &&
      status === 401
    ) {
      window.localStorage.removeItem(TOKEN_STORAGE_KEY);
      window.localStorage.removeItem("authState");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }
    if (typeof window !== "undefined" && status === 402) {
      window.dispatchEvent(new CustomEvent("testora:usage-limit", {
        detail: error.response?.data || {},
      }));
    }

    return Promise.reject(error);
  },
);
